import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/**
 * Thumbnail corner rounding segmented control, bound to the design context. Persists
 * `presentationSettings.thumbnailRadius` in edit mode (via the injected commit sink);
 * preview-only in the create modal.
 */
export const CreateShowcaseDesignCornerRoundingRow = memo(() => {
  const { thumbnailRadiusOptions, selectedThumbnailRadiusOption, handleSelectThumbnailRadius } =
    useCreateShowcaseDesign();

  return (
    <SegmentedControlRow
      data-testid="CREATE_COLLECTION_LINK_DESIGN_THUMBNAIL_RADIUS_ROW"
      label="Corner rounding"
      onSelect={handleSelectThumbnailRadius}
      options={thumbnailRadiusOptions}
      selectedOption={selectedThumbnailRadiusOption}
    />
  );
});

CreateShowcaseDesignCornerRoundingRow.displayName = 'CreateShowcaseDesignCornerRoundingRow';
